import { render, staticRenderFns } from "./Proiecte.vue?vue&type=template&id=5fc7a0bb"
import script from "./Proiecte.vue?vue&type=script&lang=js"
export * from "./Proiecte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports